/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export * from './franchise-monthly-rest.service';
export * from './franchise-monthly.dto';
